<template>
    <el-dialog :title="title" :visible.sync="dialogTableVisible" @close="closeDialog" width="80%">
        <el-table :data="list" v-loading="loading">
            <el-table-column property="order_id" label="订单ID"></el-table-column>
            <el-table-column property="customer_name" label="客户名称"></el-table-column>
            <el-table-column property="area" label="地区"></el-table-column>
            <el-table-column property="product_name_array" label="合作产品"></el-table-column>
            <el-table-column property="username" label="订单负责人"></el-table-column>
            <el-table-column property="branch_name" label="所属部门"></el-table-column>
            <el-table-column property="created_at" label="录单时间"></el-table-column>
            <el-table-column label="操作"  fixed="right">
                <template slot-scope="scope">
                    <el-button @click="handleView(scope.row)" type="text"  size="small">查看</el-button>
                </template>
            </el-table-column>
        </el-table>
        <MyPagination :linkPage="linkPage" @size-change="handleSizeChange" @current-change="handleCurrentChange"></MyPagination>
    </el-dialog>
</template>
<script>
    import GuanbiCount from "~/services/GuanbiCount";
    import MyPagination from "~/widgets/MyPagination.vue";
    export default {
        props:{
            params:{
                type: Object,
                required: true,
            },
            title:{
                type: String,
                required: false,
                default: '试用订单'
            },
        },
        components: {
            MyPagination
        },
        data(){
            return {
                list:[],
                loading: false,
                dialogTableVisible: true,
                linkPage: null,
            }
        },
        created() {
            this.getList();
        },
        methods: {
            //获取列表
            getList() {
                // loading 动画
                this.loading = true;
                GuanbiCount.getCount(this.params, 'try-conv-order')
                .then((res) => {
                    if (res.code == 0) {
                        this.list = res.data;
                    }
                    if (res._meta) {
                        this.linkPage = res._meta;
                    }
                    this.loading = false;
                })
                .catch((err) => {
                    console.error(err);
                    this.loading = false;
                });
            },

            handleView(row) {
                let routeData = this.$router.resolve({
                    path: "/order/view",
                    query: { id: row.order_id },
                });
                window.open(routeData.href, '_blank');
            },

            handleSizeChange(newSize) {
                // 处理每页条目数变化事件
                let params = this.params;
                params['perPage'] = newSize;
                this.getList(params);
            },

            handleCurrentChange(newPage) {
                let params = this.params;
                // 处理当前页码变化事件
                params['page'] = newPage;
                this.getList(params);
            },
            
            closeDialog(){
                this.dialogTableVisible = false;
                this.$emit("close", []);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/count/dialog/TryConvOrderDialog.vue